export const getLocalizedPath = (path: string | undefined): string => {
  if (!path || path.startsWith('http') || path.startsWith('#') || path.startsWith('mailto:')) {
    return path || '#'
  }

  if (typeof window === 'undefined') return path

  const currentPath = window.location.pathname
  const localeMatch = currentPath.match(/^\/([a-z]{2}(?:-[a-z]{2})?)\//i)
  const localePrefix = localeMatch ? localeMatch[1] : ''

  if (localePrefix && !path.startsWith(`/${localePrefix}/`) && path.startsWith('/')) {
    return `/${localePrefix}${path}`
  }

  return path
}

export const isActivePath = (path: string | undefined): boolean => {
  if (!path || path === '#') return false
  if (typeof window === 'undefined') return false

  const currentPath = window.location.pathname
  const localizedPath = getLocalizedPath(path)

  return (
    currentPath === localizedPath ||
    (localizedPath !== '/' && currentPath.startsWith(localizedPath + '/'))
  )
}
